<template>
  <v-container no-gutters>
    <v-row no-gutters class="pb-6">
      <v-col>
        <img ref="logo" style="max-height:220px" :src="url" />
      </v-col>
    </v-row>
    <v-row no-gutters class="justify-center pb-6">
      <v-col cols="auto">
        <v-subheader class="text-h6 pa-0 font--text font-weight-regular" style="height: auto;">
          {{ appName }}
        </v-subheader>
      </v-col>
    </v-row>
    <v-row no-gutters class="justify-center">
      <v-col cols="8" lg="7">
        <v-form>
          <authentication-input
            translation-path="login.emailOrUsername"
            autofocus
            hide-details
            v-model="credentials.username_or_email"
            @keyup.enter="loginHandler"
            class="pb-11"
            name="username"
          ></authentication-input>
          <authentication-input
            name="password"
            type="password"
            translation-path="login.password"
            v-model="credentials.password"
            hide-details
            @keyup.enter="loginHandler"
          ></authentication-input>
          <v-row no-gutters class="justify-start">
            <v-col cols="auto">
              <link-underlined
                translation-path="login.forgotPassword"
                @click="recoverPasswordHandler"
              ></link-underlined>
            </v-col>
          </v-row>
          <v-row no-gutters class="justify-end pt-6">
            <v-col cols="auto">
              <base-button
                :loading="isLoading"
                @click="loginHandler"
                translation-path="login.login"
                style="margin-right: 0px !important;"
              ></base-button>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { call, get } from 'vuex-pathify';

import logo from '@/mixins/logo';

import AuthenticationInput from '@/components/AuthenticationInput';
import LinkUnderlined from '@/components/LinkUnderlined';

export default {
  name: 'Login',
  mixins: [logo],
  components: {
    AuthenticationInput,
    LinkUnderlined,
  },
  data: () => ({
    credentials: {
      password: undefined,
      username_or_email: undefined,
    },
    url: `${process.env.VUE_APP_API_URL}/settings/logo`,
    isLoading: false,
  }),
  computed: {
    appName: get('admin/settingsValues@app_name'),
    smtpEnabled: get('admin/additionalModules@SMTP.enabled'),
    smtpConfigured: get('admin/additionalModules@SMTP.configured'),
    isSmtpWorking() {
      return this.smtpEnabled && this.smtpConfigured;
    },
  },
  methods: {
    createGtagEvent: call('gtag/createEvent'),
    login: call('authentication/login'),
    recoverPasswordHandler() {
      if (this.isSmtpWorking) {
        this.$router.push({ name: 'email' });
      } else {
        this.$store.set('snackbar/PUSH_MESSAGE!', {
          message: this.$i18n.t(`login.noSmtp`),
          color: '#333333',
          buttonType: 'text',
        });
      }
    },
    async loginHandler() {
      try {
        this.isLoading = true;
        await this.login(this.credentials);
        this.createGtagEvent({
          action: 'login',
          params: {
            user: this.credentials.username_or_email,
          },
          extra_params: {
            method: 'private',
          },
        });
        this.$router.push(this.$route.query.redirect || '/map');
        this.isLoading = false;
      } catch (error) {
        console.log(`loginHandler -> error`, error.message);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
